import dayjs, { Dayjs } from 'dayjs';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Button, DatePicker, Form, Modal, Space, Table } from 'antd';
// import { ExclamationCircleOutlined } from '@ant-design/icons'
import { DeviceProperty, getHistoryProperty, HistoryProperty, getHistoryPropertyAll } from '@/api/device-thingmodel';
import { useTableRequest } from '@/hooks';
import { isNull, isObject } from 'lodash';
import { DownloadOutlined, LineChartOutlined, TableOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { getThingModelExportData } from '@/api/data/history';
import { downloadXlsx } from '@/utils/download';
import { Line } from '@ant-design/plots';

const { RangePicker } = DatePicker;
const { useForm } = Form;

// const range = (start: number, end: number) => {
//   const result = []
//   for (let i = start; i < end; i++) {
//     result.push(i)
//   }
//   return result
// }

export type EventValue<DateType> = DateType | null;
export type RangeValue<DateType> = [EventValue<DateType>, EventValue<DateType>] | null;

export interface Tab1ModalRef {
  open: (item: DeviceProperty) => void;
}

export interface Tab1ModalProps {
  product_id?: string;
}

export const Tab1Modal = forwardRef<Tab1ModalRef, Tab1ModalProps>((props, ref) => {
  const [searchParams] = useSearchParams();
  const params = useParams<{ id: string }>();
  const [form] = useForm();
  // const [dates, setDates] = useState<RangeValue<Dayjs>>()
  const [record, setRecord] = useState<DeviceProperty>();
  // const [dataSource, setDataSource] = useState<ReportDaum[]>([])
  // const [loading, setLoading] = useState<boolean>(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { loading, dataSource, pagination, search } = useTableRequest<HistoryProperty>({
    onRequest: (param) => {
      const [start, end] = form.getFieldValue('range') || [];
      return getHistoryProperty(params.id!, {
        ...param,
        code: record?.code!,
        start: start?.valueOf()!,
        end: end?.valueOf()!,
      });
    },
  });
  const [type, setType] = useState<'line' | 'table'>('line');

  const { run: lineRun, data: lineData } = useRequest(
    (toParams?: { code?: string }) => {
      const [start, end] = form.getFieldValue('range') || [dayjs().add(-1, 'hours'), dayjs()];
      console.log({ start, end, params, record });
      return getHistoryPropertyAll(params.id!, { code: toParams?.code || record?.code!, start: start?.valueOf()!, end: end?.valueOf()! });
    },
    { manual: true },
  );

  // const { run: lineRun, data } = useRequest(getHistoryPropertyAll, { manual: true });
  const onSearch = ({ inType, code }: { inType?: 'line' | 'table'; code?: string }) => {
    if (inType ? inType === 'line' : type === 'line') {
      lineRun({ code });
      return;
    }
    search();
  };

  useImperativeHandle(ref, () => {
    return {
      open(item) {
        setRecord(item);
        setIsModalOpen(true);
        onSearch({ code: item.code });
      },
    };
  }, [params]);

  // const load = useCallback(() => {
  //   const [start, end] = form.getFieldValue('range') || []
  //   setLoading(true)
  //   getHistoryProperty(params.id!, {
  //     code: record?.code!,
  //     start: start?.valueOf()!,
  //     end: end?.valueOf()!,
  //   }).then(resp => {
  //     if (resp.success) {
  //       setDataSource(resp.result.list || [])
  //     }
  //   }).finally(() => {
  //     setLoading(false)
  //   })
  // }, [record?.code, form, params.id])

  // useEffect(() => {
  //   if (isModalOpen) {
  //     load()
  //   }
  // }, [isModalOpen])

  useEffect(() => {
    const start_at = Number(searchParams.get('start_at'));
    const end_at = Number(searchParams.get('end_at'));
    start_at && end_at && form.setFieldValue('range', [dayjs(start_at), dayjs(end_at)]);
  }, []);

  const { run: exportRun, loading: exportLoading } = useRequest(getThingModelExportData, {
    manual: true,
    onSuccess(data) {
      const fileName = window.decodeURI(data.headers['content-disposition']?.split('=')[1] || '');
      downloadXlsx(data.data, fileName);
    },
  });

  return (
    <Modal
      title="功能历史数据"
      open={isModalOpen}
      footer={null}
      width={1000}
      onCancel={() => {
        setIsModalOpen(false);
      }}
    >
      <Form layout="inline" className="mb5">
        <Form.Item label="功能名称">{record?.name}</Form.Item>
        <Form.Item label="标识符">{record?.code}</Form.Item>
        <Form.Item label="数据类型">{record?.data_type}</Form.Item>
      </Form>
      <div className="mb10 flex" style={{ justifyContent: 'space-between' }}>
        <Form layout="inline" form={form}>
          <Form.Item name="range" initialValue={[dayjs().add(-1, 'hours'), dayjs()]}>
            <RangePicker
              format="YYYY-MM-DD HH:mm:ss"
              placeholder={['开始日期', '结束日期']}
              // onCalendarChange={val => setDates(val)}
              // onOpenChange={(open) => {
              //   if (open) {
              //     form.setFieldValue('range', []);
              //   } else {
              //     // setDates(undefined)
              //   }
              // }}
              showTime={{
                hideDisabledOptions: true,
                defaultValue: [dayjs(dayjs().format('YYYY-MM-DD')), dayjs(dayjs().format('YYYY-MM-DD'))],
              }}
              presets={[
                { label: '最近1小时', value: [dayjs().add(-1, 'hours'), dayjs()] },
                { label: '最近3小时', value: [dayjs().add(-3, 'hours'), dayjs()] },
                { label: '最近24小时', value: [dayjs().add(-24, 'hours'), dayjs()] },
              ]}
              // renderExtraFooter={() => {
              //   return (
              //     <Text type="warning" style={{ fontSize: 12 }}>
              //       <ExclamationCircleOutlined className="ml20 mr10" />
              //       时间查询跨度应选择二十四小时之内，否则数据加载将消耗很长时间
              //     </Text>
              //   )
              // }}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              onClick={() => {
                onSearch({});
              }}
            >
              查询
            </Button>
            <Button
              className="ml10"
              onClick={() => {
                form.resetFields();
              }}
            >
              重置
            </Button>
          </Form.Item>
        </Form>
        <Space.Compact>
          <Button
            icon={<TableOutlined />}
            type={type === 'table' ? 'primary' : 'default'}
            onClick={() => {
              if (type === 'table') return;
              setType('table');
              onSearch({ inType: 'table' });
            }}
          />
          <Button
            type={type === 'line' ? 'primary' : 'default'}
            icon={<LineChartOutlined />}
            onClick={() => {
              if (type === 'line') return;
              setType('line');
              onSearch({ inType: 'line' });
            }}
          />
          <Button
            icon={<DownloadOutlined />}
            loading={exportLoading}
            onClick={() => {
              const range = form.getFieldValue('range');
              exportRun({
                // @ts-ignore
                query: [
                  {
                    product_id: props?.product_id || '',
                    device_id: params.id!,
                    code: record?.code!,
                  },
                ],
                range: range.map((v: Dayjs) => v.valueOf()),
                isAll: true,
              });
              // exportRun({ code: [record?.code!], range: range.map((v: Dayjs) => v.valueOf()), isAll: true, device_ids: [params.id!] });
            }}
          />
        </Space.Compact>
      </div>

      {type === 'line' && (
        <div style={{ height: 400, width: '100%' }}>
          <Line
            // @ts-ignore
            data={lineData?.result?.list || []}
            xField="time"
            yField="value"
            xAxis={{ label: { formatter: (text) => dayjs(Number(text)).format('YYYY-MM-DD HH:mm:ss') } }}
            tooltip={{ title: '数据', formatter: (data) => ({ name: dayjs(data.time).format('YYYY-MM-DD HH:mm:ss'), value: data.value }) }}
          ></Line>
        </div>
      )}
      {type === 'table' && (
        <Table
          bordered
          size="small"
          scroll={{ y: 400 }}
          loading={loading}
          dataSource={dataSource}
          pagination={pagination}
          rowKey="time"
          columns={[
            {
              title: '时间',
              key: 'time',
              dataIndex: 'time',
              width: 500,
              render(value) {
                return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
              },
            },
            {
              title: '原始值',
              key: 'value',
              dataIndex: 'value',
              render: (_v, item) => {
                // @ts-ignore
                return isNull(item.value) ? '-' : isObject(item.value) ? JSON.stringify(item.value) : String(item.value);
              },
            },
          ]}
        ></Table>
      )}
      {/* <div style={{ margin: '0 auto', textAlign: 'center' }}>
        <Pagination {...pagination} style={{ textAlign: 'right', marginTop: 10, justifyContent: 'center' }} showSizeChanger showQuickJumper showTotal={(total) => `共 ${total} 条`}></Pagination>
      </div> */}
    </Modal>
  );
});

export default Tab1Modal;
